import React from 'react'
import processing from "./processing.gif"
const Spinner = () => {
  return (
    <div className='text-center'>
        <img src={processing} alt="processing"/>
    </div>
  )
}

export default Spinner;